export default {
  colon: str => str.replaceAll(':', '_'),
  spaces: (str, empty = false) => str.replaceAll(' ', empty ? '' : '_'),
  spacesDash: str => str.replaceAll(' ', '-'),
  spacesPlus: str => str.replaceAll(' ', '+'),
};
